// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* home-players__container */
.home-players__player {
    background: var(--white-color);
    border-radius: 14px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;
    padding: 16px 24px;
    gap: 12px;
    cursor: pointer;
}
.home-players__player__photo {
    width: 112px;
    height: 112px;
    border-radius: 50%;
    display: contents;
}

.home-players__player__photo img {
    width: inherit;
    height: inherit;
    border-radius: 50%;
}

.home-players__player__photo .icon-ball {
    font-size: 80px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 10px;
    height: 100px;
    color: var(--white-color);
}

.home-players__player__info {
    width: -webkit-fill-available;
}
.home-players__player__info__data {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.home-players__player__info__data-player {
    width: 75%;
}

.home-players__player__info__data-player .baloa-names {
    color: var(--primary-very-dark-color);
    display: flex;
    align-self: center;
}

.home-players__player__info__data-player .baloa-table{
    color: var(--basic-gray-color);
    margin-bottom: 12px;
}

.home-players__player__info__data-player .hubicon-award_star {
    font-size: 20px;
    margin-left: var(--space-quarter);
}

.home-players__player__info__data-location {
    text-align: right;
    width: 25%;
}

.home-players__player__info__data-location img{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 8px;
}

.home-players__player__info__data-location .icon-ball {
    font-size: 14px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 3px;
    height: 20px;
    color: var(--white-color);
    margin-right: 8px;
}

.home-players__player__info__data-location__row{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
}

.home-players__player__info__data-location .icon-location{
    font-size: 20px;
    color: var(--new-green-color);
    margin-right: 8px;
}

.home-players__player__info__data-location span{
    text-transform: none;
}
.home-players__player__info__data-location p {
    text-transform: lowercase;
}

.home-players__player__info__data-location p::first-letter {
    text-transform: capitalize;
}

.home-players__player__info__description {
    padding: 12px;
    background: var(--new-background-color);
}

.home-players__player__info__data-player__positions {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.home-players__player__info__data-player__positions .primary-position.baloa-table{
    color: var(--white-color);
    background: var(--new-green-color);
    border-radius: 23px;
    padding: 4px 6px;
    margin-right: 12px;
}

.home-players__player__info__data-player__positions .secondary-position.baloa-table{
    color: var(--primary-very-dark-color);
    background: var(--new-grey-light-background-color);
    border: 1px solid var(--new-grey-border-color);
    border-radius: 23px;
    padding: 4px 6px;
    margin-right: 12px;
}

.home-players__player__info__data-player__attributes {
    display: flex;
    align-items: center;
    gap: 12px;
}

.home-players__player__info__data-player__attributes .hubicon-assists,
.home-players__player__info__data-player__attributes .hubicon-weight-scale,
.home-players__player__info__data-player__attributes .hubicon-ruler {
    font-size: 20px;
    display: flex;
}

.home-players__player__info__data-player__attributes .baloa-table {
    margin-left: 8px;
    color: var(--primary-dark-color);
}

.home-players__empty {
    padding: 150px 0;
    text-align: center;
}

.home-players__empty .baloa-normal-medium {
    color: var(--primary-dark-color);
    margin-top: 8px;
}

.home-players__player__info__data-location__row.baloa-table {
    color: var(--new-green-color);
}

.home-players__player__info__data-location__row .hubicon-play_circle:before {
    color: var(--new-green-color);
    font-size: 20px;
    margin-right: 4px;
}

.home-players__container .baloa-pro-subscription-widget__container {
    margin-bottom: var(--space);
    padding: var(--space) var(--space-and-half);
    border: none;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .home-players__search-container {
        background: var(--white-color);
        padding: 12px 12px 8px 12px;
    }
    .home-players__search-container .input-search__input{
        background: var(--new-background-color);
        border-radius: 5px;
        width: -webkit-fill-available;
    }
    
    .home-players__search-container .input-search__input .MuiInputBase-root{
        padding: 8px 16px;
    }
    
    .home-players__search-container .input-search__input .icon-search {
        color: #949F9A;
    }

    .home-players__search-container__title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
    }

    .home-players__search-container__title.baloa-headline-2 {
        color: var(--new-text-link-color);
    }

    .home-players__close_icon {
        color: var(--primary-very-dark-color);
        font-size: var(--space-x2);
        cursor: pointer;
        margin-left: auto;
        margin-right: 8px;
    }

    .home-players__mobile-button-filter {
        padding: 6px 10px;
        border: 1px solid var(--new-gray-background-color);
        background: var(--white-color);
        width: fit-content;
        border-radius: 5px;
        display: flex;
        align-items: center;
        margin-top: 12px;
    }

    .home-players__mobile-button-filter .baloa-names {
        font-weight: var(--font-regular);
    }

    .home-players__container {
        padding: 10px;
        margin-top: 58px;
    }

    .home-players__player {
        padding: 10px;
        flex-wrap: wrap;
        margin-bottom: 10px;
    }

    .home-players__player__photo {
        width: 56px;
        height: 56px;
    }
    
    .home-players__player__photo .icon-ball {
        font-size: 50px;
        padding: 3px;
        height: 56px;
    }

    .home-players__player__info__data-player__attributes .hubicon-assists,
    .home-players__player__info__data-player__attributes .hubicon-weight-scale,
    .home-players__player__info__data-player__attributes .hubicon-ruler {
        font-size: 14px;
    }

    .home-players__player__info {
        width: calc(100% - 68px);
    }

    .home-players__player-mobile {
        width: 100%;
    }

    .home-players__player__info__data-location {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
    }

    .home-players__player__info__data-location .icon-location {
        margin-right: 6px;
    }

    .home-players__player__info__data-location__row {
        justify-content: flex-start;
    }

    .home-players__player__info__data-location__row__bullet {
        font-size: 24px;
        color: var(--new-gray-color);
        padding: 0 8px;
    }

    .home-players__player__info__data-player .baloa-table {
        margin-bottom: 4px;
    }

    .home-players__player__info__data-player__positions {
        margin-bottom: 4px;
        flex-wrap: wrap;
    }

    .home-players__player__info__data-player__positions .primary-position.baloa-table {
        padding: 2px;
    }

    .home-players__player__info__data-player__positions .secondary-position.baloa-table {
        padding: 2px;
    }

    .home-players__player__info__description {
        padding: 8px;
    }

    .home-players__player__info__data-player {
        width: 100%;
    }

    .home-players__container .baloa-pro-subscription-widget__container {
        margin-bottom: 10px;
        margin-top: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-players/HomePlayersComponent.styles.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,kDAAkD;IAClD,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;;IAGI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,YAAY;AAChB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,8BAA8B;QAC9B,2BAA2B;IAC/B;IACA;QACI,uCAAuC;QACvC,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,qCAAqC;QACrC,0BAA0B;QAC1B,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,kDAAkD;QAClD,8BAA8B;QAE9B,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,YAAY;IAChB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,4BAA4B;QAC5B,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;AACJ","sourcesContent":["/* home-players__container */\n.home-players__player {\n    background: var(--white-color);\n    border-radius: 14px;\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 24px;\n    padding: 16px 24px;\n    gap: 12px;\n    cursor: pointer;\n}\n.home-players__player__photo {\n    width: 112px;\n    height: 112px;\n    border-radius: 50%;\n    display: contents;\n}\n\n.home-players__player__photo img {\n    width: inherit;\n    height: inherit;\n    border-radius: 50%;\n}\n\n.home-players__player__photo .icon-ball {\n    font-size: 80px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 10px;\n    height: 100px;\n    color: var(--white-color);\n}\n\n.home-players__player__info {\n    width: -webkit-fill-available;\n}\n.home-players__player__info__data {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.home-players__player__info__data-player {\n    width: 75%;\n}\n\n.home-players__player__info__data-player .baloa-names {\n    color: var(--primary-very-dark-color);\n    display: flex;\n    align-self: center;\n}\n\n.home-players__player__info__data-player .baloa-table{\n    color: var(--basic-gray-color);\n    margin-bottom: 12px;\n}\n\n.home-players__player__info__data-player .hubicon-award_star {\n    font-size: 20px;\n    margin-left: var(--space-quarter);\n}\n\n.home-players__player__info__data-location {\n    text-align: right;\n    width: 25%;\n}\n\n.home-players__player__info__data-location img{\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.home-players__player__info__data-location .icon-ball {\n    font-size: 14px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 3px;\n    height: 20px;\n    color: var(--white-color);\n    margin-right: 8px;\n}\n\n.home-players__player__info__data-location__row{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-bottom: 8px;\n}\n\n.home-players__player__info__data-location .icon-location{\n    font-size: 20px;\n    color: var(--new-green-color);\n    margin-right: 8px;\n}\n\n.home-players__player__info__data-location span{\n    text-transform: none;\n}\n.home-players__player__info__data-location p {\n    text-transform: lowercase;\n}\n\n.home-players__player__info__data-location p::first-letter {\n    text-transform: capitalize;\n}\n\n.home-players__player__info__description {\n    padding: 12px;\n    background: var(--new-background-color);\n}\n\n.home-players__player__info__data-player__positions {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n}\n\n.home-players__player__info__data-player__positions .primary-position.baloa-table{\n    color: var(--white-color);\n    background: var(--new-green-color);\n    border-radius: 23px;\n    padding: 4px 6px;\n    margin-right: 12px;\n}\n\n.home-players__player__info__data-player__positions .secondary-position.baloa-table{\n    color: var(--primary-very-dark-color);\n    background: var(--new-grey-light-background-color);\n    border: 1px solid var(--new-grey-border-color);\n    border-radius: 23px;\n    padding: 4px 6px;\n    margin-right: 12px;\n}\n\n.home-players__player__info__data-player__attributes {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.home-players__player__info__data-player__attributes .hubicon-assists,\n.home-players__player__info__data-player__attributes .hubicon-weight-scale,\n.home-players__player__info__data-player__attributes .hubicon-ruler {\n    font-size: 20px;\n    display: flex;\n}\n\n.home-players__player__info__data-player__attributes .baloa-table {\n    margin-left: 8px;\n    color: var(--primary-dark-color);\n}\n\n.home-players__empty {\n    padding: 150px 0;\n    text-align: center;\n}\n\n.home-players__empty .baloa-normal-medium {\n    color: var(--primary-dark-color);\n    margin-top: 8px;\n}\n\n.home-players__player__info__data-location__row.baloa-table {\n    color: var(--new-green-color);\n}\n\n.home-players__player__info__data-location__row .hubicon-play_circle:before {\n    color: var(--new-green-color);\n    font-size: 20px;\n    margin-right: 4px;\n}\n\n.home-players__container .baloa-pro-subscription-widget__container {\n    margin-bottom: var(--space);\n    padding: var(--space) var(--space-and-half);\n    border: none;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .home-players__search-container {\n        background: var(--white-color);\n        padding: 12px 12px 8px 12px;\n    }\n    .home-players__search-container .input-search__input{\n        background: var(--new-background-color);\n        border-radius: 5px;\n        width: -webkit-fill-available;\n    }\n    \n    .home-players__search-container .input-search__input .MuiInputBase-root{\n        padding: 8px 16px;\n    }\n    \n    .home-players__search-container .input-search__input .icon-search {\n        color: #949F9A;\n    }\n\n    .home-players__search-container__title {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 12px 0;\n    }\n\n    .home-players__search-container__title.baloa-headline-2 {\n        color: var(--new-text-link-color);\n    }\n\n    .home-players__close_icon {\n        color: var(--primary-very-dark-color);\n        font-size: var(--space-x2);\n        cursor: pointer;\n        margin-left: auto;\n        margin-right: 8px;\n    }\n\n    .home-players__mobile-button-filter {\n        padding: 6px 10px;\n        border: 1px solid var(--new-gray-background-color);\n        background: var(--white-color);\n        width: -moz-fit-content;\n        width: fit-content;\n        border-radius: 5px;\n        display: flex;\n        align-items: center;\n        margin-top: 12px;\n    }\n\n    .home-players__mobile-button-filter .baloa-names {\n        font-weight: var(--font-regular);\n    }\n\n    .home-players__container {\n        padding: 10px;\n        margin-top: 58px;\n    }\n\n    .home-players__player {\n        padding: 10px;\n        flex-wrap: wrap;\n        margin-bottom: 10px;\n    }\n\n    .home-players__player__photo {\n        width: 56px;\n        height: 56px;\n    }\n    \n    .home-players__player__photo .icon-ball {\n        font-size: 50px;\n        padding: 3px;\n        height: 56px;\n    }\n\n    .home-players__player__info__data-player__attributes .hubicon-assists,\n    .home-players__player__info__data-player__attributes .hubicon-weight-scale,\n    .home-players__player__info__data-player__attributes .hubicon-ruler {\n        font-size: 14px;\n    }\n\n    .home-players__player__info {\n        width: calc(100% - 68px);\n    }\n\n    .home-players__player-mobile {\n        width: 100%;\n    }\n\n    .home-players__player__info__data-location {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        width: 100%;\n    }\n\n    .home-players__player__info__data-location .icon-location {\n        margin-right: 6px;\n    }\n\n    .home-players__player__info__data-location__row {\n        justify-content: flex-start;\n    }\n\n    .home-players__player__info__data-location__row__bullet {\n        font-size: 24px;\n        color: var(--new-gray-color);\n        padding: 0 8px;\n    }\n\n    .home-players__player__info__data-player .baloa-table {\n        margin-bottom: 4px;\n    }\n\n    .home-players__player__info__data-player__positions {\n        margin-bottom: 4px;\n        flex-wrap: wrap;\n    }\n\n    .home-players__player__info__data-player__positions .primary-position.baloa-table {\n        padding: 2px;\n    }\n\n    .home-players__player__info__data-player__positions .secondary-position.baloa-table {\n        padding: 2px;\n    }\n\n    .home-players__player__info__description {\n        padding: 8px;\n    }\n\n    .home-players__player__info__data-player {\n        width: 100%;\n    }\n\n    .home-players__container .baloa-pro-subscription-widget__container {\n        margin-bottom: 10px;\n        margin-top: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
